import { render } from "./billingPolicy.vue?vue&type=template&id=76e6e270&scoped=true"
import script from "./billingPolicy.vue?vue&type=script&lang=js"
export * from "./billingPolicy.vue?vue&type=script&lang=js"

import "./billingPolicy.vue?vue&type=style&index=0&id=76e6e270&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e6e270"]])

export default __exports__